import { render, staticRenderFns } from "./provision.vue?vue&type=template&id=5a10fef6&scoped=true&"
import script from "./provision.vue?vue&type=script&lang=js&"
export * from "./provision.vue?vue&type=script&lang=js&"
import style0 from "./provision.vue?vue&type=style&index=0&id=5a10fef6&less=true&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10fef6",
  null
  
)

export default component.exports